import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { issuesVisibleGetSlice } from './get';

export const issuesVisibleReducers = combineReducers({
	get: issuesVisibleGetSlice.asyncReducers
});

export const issuesVisibleWatchers = combineAllWatchers([ issuesVisibleGetSlice.asyncWatchers ]);
